import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api";
import { CesiumViewer } from "../viewer/CesiumViewer";

export function SharePage() {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<{
    name: string;
    tilesetUrl: string;
    kind: "mesh" | "pointcloud";
  } | null>(null);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const share = await api.share(token);
        if (!cancelled) {
          setData({
            name: share.name,
            tilesetUrl: share.tilesetUrl,
            kind: share.kind ?? "mesh",
          });
        }
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : "Unavailable");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="page center-page">
        <div className="card">Loading project…</div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="page center-page">
        <div className="card">
          <h1>Link unavailable</h1>
          <p className="muted">{error ?? "This sharing link is disabled or the model is not ready."}</p>
        </div>
      </div>
    );
  }

  return <CesiumViewer tilesetUrl={data.tilesetUrl} title={data.name} kind={data.kind} />;
}
